var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.434,
    height: 23.421,
    viewBox: "0 0 20.434 23.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gift",
    transform: "translate(-72.5 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M83.893,33.421h7.325a1.718,1.718,0,0,0,1.716-1.709V25.893H83.893v7.528ZM72.5,31.712a1.718,1.718,0,0,0,1.716,1.709h7.8V25.893H72.5v5.819ZM91.215,16.34H87.392a6.312,6.312,0,0,0,1.219-.868c1.594-1.479,1.881-3.609.643-4.758A2.875,2.875,0,0,0,87.27,10a4.739,4.739,0,0,0-3.148,1.31A6.256,6.256,0,0,0,82.8,13.128a6.256,6.256,0,0,0-1.326-1.819A4.738,4.738,0,0,0,78.324,10a2.871,2.871,0,0,0-1.984.715c-1.24,1.15-.951,3.279.641,4.758a6.387,6.387,0,0,0,1.219.868H74.216A1.718,1.718,0,0,0,72.5,18.049v5.98h9.517v-6.94a1.646,1.646,0,0,0,.736-.425c.017-.014.026-.033.043-.048.014.014.026.033.043.048a2.937,2.937,0,0,0,1.054.425v6.938h9.041V18.049a1.72,1.72,0,0,0-1.718-1.709Zm-9.648-.961a.908.908,0,0,1-.437.072A4.956,4.956,0,0,1,78.174,14.2a2.408,2.408,0,0,1-.856-1.644.7.7,0,0,1,.213-.564,1.2,1.2,0,0,1,.791-.246,3,3,0,0,1,1.953.841,3.732,3.732,0,0,1,1.293,2.794Zm2.486.024h0a3.607,3.607,0,0,1,1.264-2.82,3.006,3.006,0,0,1,1.953-.841,1.2,1.2,0,0,1,.791.246.7.7,0,0,1,.213.564A2.413,2.413,0,0,1,87.42,14.2a4.936,4.936,0,0,1-2.956,1.252,1.566,1.566,0,0,1-.411-.045Z",
    fill: "#375dbc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.d85b19cd16a6e2602b7dba233186472b.svg";
export { ForwardRef as ReactComponent };